import { Injectable, } from '@angular/core';
import { FileConstants } from '../../../constants/file-constants'; //constants
import { MatDialog } from "@angular/material/dialog";
import { LoaderService } from './loader-util';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { FileViolationDialog } from '../../dialogs/candidate/file-violation-dialog/file-violations-dialog';
import { AppConstants } from '../../../constants/app-constants';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class FileUploadUtil {
    fileSrcstring$: string;

    constructor(public dialog: MatDialog, public bottomSheet: MatBottomSheet, public snackBar: MatSnackBar, public loaderService: LoaderService, private http: HttpClient) { }

    async uploadFile(event, orgid) {
        // initialization 
        let finalfiles = event.target.files[0];
        this.fileSrcstring$ = null;
        let files = event.target.files;
        let fileType = files[0].type;
        let fileSize = files[0].size;
        let templocation;
        if (this.isAllowedFileType(fileType) && this.isAllowedFileSize(fileSize)) { // Checking FILE TYPE & SIZE
            if (fileType !== FileConstants.PDF_MIME_TYPE) { // !pdf
                let result: any = await this.convertDocxToPdf(files, orgid);
                // this.fileSrcstring$ = result.file;
                // templocation = result.templocation;
                if (result != null) {
                    this.fileSrcstring$ = result.file;
                    templocation = result.templocation;
                } else {
                    this.fileSrcstring$ = null;
                }
            }
            else if (fileType === FileConstants.PDF_MIME_TYPE) { // === pdf
                this.fileSrcstring$ = await this.getPdfFromReader(files);
            }
        }
        else {
            // popup - file type
            this.dialog.open(FileViolationDialog, {
                data: {
                    type: 'FILE_TYPE_EXCEPTION',
                    filetype: fileType,
                    filesize: fileSize,
                    message: "Uploaded file type is not permitted (or) Uploaded file size exceeds 2 mb",
                    title: 'Upload Denied'
                },
                width: '530px',
                height: '240px',
            });
            return null;
        }

        return this.fileSrcstring$;
        //return outputfile;
    }

    // upload file
    async uploadFileMultipart(event, orgid,fileName?) {
        // initialization 
        let finalfiles = event.target.files[0];
        this.fileSrcstring$ = null;
        let files = event.target.files;
        const file: File = event.target.files[0];
        let fileType = files[0].type;
        let fileSize = files[0].size;
        let templocation;

        let isAllowedFileSize: any;
        let maxFileSize: string;
        const FormCustomization = ['employmentapplicationform', 'bgvform', 'joiningform', 'medicalreport', 'pfuan', 'conflictofinterestform', 'confidentialityform', 'Resume', 'Offer'];
        if (fileName && FormCustomization.includes(fileName)) {
            maxFileSize = "2 mb";
            isAllowedFileSize = fileSize <= FileConstants.FILE_SIZE_LARGE; // 2mb
        } else {
            maxFileSize = "750 kb";
            isAllowedFileSize = fileSize <= FileConstants.FILE_SIZE_GENERAL;// 750 kb
        }
        if (this.isAllowedFileType(fileType) && isAllowedFileSize) { // Checking FILE TYPE & SIZE
            if (fileType !== FileConstants.PDF_MIME_TYPE) { // !pdf
                // let result = await this.convertDocxToPdf(files, orgid);
                // // let result = this.convertToBytes(file);
                // this.fileSrcstring$ = result['files'];
                // templocation = result['convertedfiletmplocation'];
                let result: any = await this.convertDocxToPdf(files, orgid);
                if (result != null) {
                    this.fileSrcstring$ = result.file;
                    templocation = result.templocation;
                    this.loaderService.toggleLoader(false);
                }
            }
            else if (fileType === FileConstants.PDF_MIME_TYPE) { // === pdf
                this.fileSrcstring$ = await this.getPdfFromReader(files);
            }
        }
        else {
            // popup - file type
            this.dialog.open(FileViolationDialog, {
                data: {
                    type: 'FILE_TYPE_EXCEPTION', filetype: fileType, filesize: fileSize,message: `Uploaded file type is not permitted (or) Uploaded file size exceeds ${maxFileSize}.`,
                    title: 'Upload Denied'
                }
            });
            return null;
        }
        let outputfile = {
            'bytes': this.fileSrcstring$,
            'multipart': finalfiles,
            'templocation': templocation
        }
        //  return this.fileSrcstring$;
        return outputfile;
    }

    convertToBytes(file: File): void {
        const reader: FileReader = new FileReader();
        reader.onload = () => {
            const bytesArray: Uint8Array | null = new Uint8Array(reader.result as ArrayBuffer);
            if (bytesArray) {
                // You can now use the bytesArray for further processing, such as uploading to a server.
                let data = {
                    files: bytesArray
                }
                return data;

            }
        };
        reader.readAsArrayBuffer(file);
    }

    // reads the file
    async getPdfFromReader(files) {
        return new Promise<any>((resolve, reject) => {
            var reader = new FileReader();
            reader.readAsDataURL(files[0]);
            reader.onload = (event: any) => {
                var response = event.target.result;
                if (response && response != null && response != '') {
                    resolve(response.replace(FileConstants.REPLACE_STRING, ''));
                }
                else {
                    resolve(null);
                }
            };
        });
    }

    // converts the docx to pdf
    async convertDocxToPdf(files, orgid) {
        // this.loaderService.toggleLoader(true);
        // let result: any = await this.convertDocFileToPDF(files[0], orgid).toPromise();
        // if (result && result.files && result.files != null && result.files != '') {
        //     this.loaderService.toggleLoader(false);
        //     result.files.replace(FileConstants.REPLACE_STRING, '')
        //     return result;
        // }
        // else {
        //     this.loaderService.toggleLoader(false);
        //     return null;
        //     // this.snackBar.open('File Conversion Failed!', 'OK',
        //     // { duration: 1000, verticalPosition: 'bottom' });
        // }

        return new Promise(async (resolve, reject) => {
            this.loaderService.toggleLoader(true);
            await this.convertDocFileToPDF(files[0], orgid).subscribe((result: any) => {
                if (result && result.files && result.files != null && result.files != '') {
                    let convertedresult = {
                        'file': result.files.replace(FileConstants.REPLACE_STRING, ''),
                        'templocation': result.convertedfiletmplocation
                    }
                    resolve(convertedresult);
                    this.loaderService.toggleLoader(false);
                } else {
                    this.dialog.open(FileViolationDialog, {
                        data: { message: 'Kindly convert to PDF and Upload.', title: 'File Conversion Failed' }
                    });
                    resolve(null);
                    // this.loaderService.toggleLoader(false);
                    // this.snackBar.open('File Conversion Failed!', 'OK',
                    //     { duration: 3000, verticalPosition: 'bottom' });
                }
            }, error => {
                this.dialog.open(FileViolationDialog, {
                    data: { message: 'Kindly convert to PDF and Upload.', title: 'File Conversion Failed' }
                });
                reject(error);
                // this.loaderService.toggleLoader(false);
                // this.snackBar.open('File Conversion Failed!', 'OK',
                //     { duration: 3000, verticalPosition: 'bottom' });
            });
        });
    }

    // verifies file type
    isAllowedFileType(type) {
        return FileConstants.ALLOWED_FILE_TYPES.find(e => e === type);
    }

    // verifies file size
    isAllowedFileSize(size) {
        if (size <= FileConstants.ALLOWED_FILE_SIZE) { // size is < 10 MB 
            return true;
        }
        else { return false; }
    }

    // converts doc to pdf
    convertDocFileToPDF(file, orgid) {
        const url = environment.SERVER_URL + AppConstants.CONVERT_TO_PDF;
        const body = new FormData();
        const headers = new HttpHeaders();
        body.append('orgid', orgid);
        body.append('inputfile', file);
        return this.http.post(url, body);
    }

    // verifies if image is valid
    isImageValid(event, device,formcontrol?) {
        let fileList: FileList = event.target.files;
        let fileType = fileList[0].type;
        let fileSize = fileList[0].size;
        let maxFileSize;
        if(formcontrol === 'profilepic'){
            maxFileSize = "500 kb";
        }else{
            maxFileSize = "750 kb";
        }

        if (this.isAllowedImageType(fileType) && this.isAllowedImageSize(fileSize,formcontrol)) {
            return true;
        }
        else {
            if (device)
                this.dialog.open(FileViolationDialog, {
            //message: `Uploaded file type is not permitted (or) Uploaded file size exceeds ${maxFileSize}.`
                    data: {
                        type: 'FILE_TYPE_EXCEPTION', filetype: fileType, filesize: fileSize,message: `Uploaded file type is not permitted (or) Uploaded file size exceeds ${maxFileSize}.`,
                        title: 'Upload Denied'
                    }
                });
            else
                this.bottomSheet.open(FileViolationDialog, {
                    data: {
                        type: 'FILE_TYPE_EXCEPTION', filetype: fileType, filesize: fileSize, message: `Uploaded file type is not permitted (or) Uploaded file size exceeds ${maxFileSize}.`,
                        title: 'Upload Denied'
                    }
                });
            return false;
        }
    }

    // verifies if image type is valid
    isAllowedImageType(type) {
        return FileConstants.ALLOWED_IMAGE_TYPES.find(e => e === type);
    }

    // verifies if image size is valid
    isAllowedImageSize(size,formcontrol?) {
        if(formcontrol === 'profilepic'){
            if (size <= FileConstants.ALLOWED_IMAGE_SIZE) { // size is < Allowed size
                return true;
            }
            else { return false; }
        }else{
            if (size <= FileConstants.FILE_SIZE_GENERAL) { // size is < Allowed size
                return true;
            }
            else { return false; }
        }

    }

}